export const choreApproveTranslateEs = {
    APPROVE_AND_PAY:{
        PAY_FLOW:{
          PAY_DESCRIPTION_PART_1: "!Genial! la",
          PAY_DESCRIPTION_PART_2: "recompensa por la misión ha sido transferida a",
          PAY_DESCRIPTION_PART_3: "cuenta",
          ADD_NEW_CHORE_BUTTON:"Agregar nueva misión",
          GO_TO_HOME_BUTTON:"Ir a la pagina principal",
          LABEL_PAY:"¿No es eso mágico?"
        },
        NOT_ENOUGH_FUNDS:{
          DESCRIPTION: "¡Vaya! Parece que no tienes suficientes fondos en tu cuenta.",
          FUND_ACCOUNT_BUTTON: "Fondear cuenta",
          PAY_LAYER_BUTTON: "Pagar mas tarde",
          ERROR:{
            DESCRIPTION:"Nos encontramos con un problema con nuestro servicio. Por favor, inténtelo de nuevo más tarde.",
            BUTTON:"Pagar mas tarde"
          }
        }
      },
}